<template>
   <div class="page_header2023">
      <!-- 新的头部 -->
      <div class="header">
         <div class="header_top">
            <div class="header_top_img">
               <img src="../../assets/images/isfal/logo.png" alt="">
            </div>
            <div class="header_top_input">
               <el-input style="width:600px;" v-model="keywork">
                  <i slot="suffix" class="el-input__icon el-icon-search" @click="onsearch"></i>
               </el-input>
            </div>
            <div class="header_top_dz">
               <img src="../../assets/images/isfal/dh.png" alt="">
               <p>Email：isfalcontact@gmail.com</p>
            </div>
         </div>
      </div>
      <div class="menu_menu">
         <div class="menu_menu_1">
            <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"
               background-color="#2B2B2B" text-color="#fff" active-background-color="#1F87E8"
               active-text-color="#1F87E8">
               <el-menu-item index="1">Home</el-menu-item>
               <el-submenu index="2">
                  <template slot="title">About us</template>
                  <el-menu-item index="2-1">About ISFAL</el-menu-item>
                  <el-menu-item index="2-2">Founders and Experts</el-menu-item>
                  <el-menu-item index="2-3">Partners</el-menu-item>
                  <el-menu-item index="2-4">Contact Us</el-menu-item>
               </el-submenu>
               <el-submenu index="3">
                  <template slot="title">Certification</template>
                  <el-menu-item index="3-1">Certification System</el-menu-item>
                  <el-menu-item index="3-2">Certification Officers</el-menu-item>
                  <el-menu-item index="3-3">Certificate Search</el-menu-item>
               </el-submenu>
               <el-submenu index="4">
                  <template slot="title">Approach</template>
                  <el-menu-item index="4-1">Basic Theory</el-menu-item>
                  <el-menu-item index="4-2">Methodological Tools</el-menu-item>
                  <el-menu-item index="4-3">Key Skills</el-menu-item>
               </el-submenu>
               <el-submenu index="5">
                  <template slot="title">Case</template>
                  <el-menu-item index="5-1">Leadership Development</el-menu-item>
                  <el-menu-item index="5-2">Organizational Development</el-menu-item>
                  <el-menu-item index="5-3">Social Development</el-menu-item>
                  <el-menu-item index="5-4">Professional Research</el-menu-item>
               </el-submenu>
               <el-submenu index="6">
                  <template slot="title">Learning</template>
                  <el-menu-item index="6-1">Ravens Speech</el-menu-item>
                  <el-menu-item index="6-2">Expert Sharing</el-menu-item>
                  <el-menu-item index="6-3">Professional Publications</el-menu-item>
               </el-submenu>
               <!-- <el-menu-item index="7">Conference</el-menu-item> -->
               <el-submenu index="7">
                  <template slot="title">Conference</template>
                  <el-menu-item index="7-1">Conference@2024</el-menu-item>
                  <el-menu-item index="7-2">Conference@2023</el-menu-item>
               </el-submenu>
            </el-menu>
         </div>
      </div>
      <div class="suspension_box_asd1" v-if="showScrollButton">
         <div class="suspension">
            <div :class="showScrollButton==true?'suspension_box_active' :'suspension_box'" @click="scrollToTop">
               <p class="iconfont">&#xe62e;</p>
               <!-- <p class="name">回到顶部</p> -->
            </div>
         </div>
      </div>
   </div>
</template>

<script>
   import "@/assets/css/pageheader.less"
   import {
      mapState
   } from "vuex";
   export default {
      beforeMount() {
         window.addEventListener('beforeunload', this.handleBeforeUnload);
         console.log('11111111111')
         var key = JSON.parse(localStorage.getItem("daohang"));
         console.log(key)
         this.activeIndex2 = key
         this.keywork = ''
         // next();
         if (key == '1') {
            this.$router.push('/index')
         }
      },
      beforeDestroy() {
         window.removeEventListener('beforeunload', this.handleBeforeUnload);
      },
      name: 'page_header2023',
      components: {},
      computed: {
         ...mapState({
            "navList": state => state.navigation.navList,
            "loginStatus": state => state.user.loginStatus,
            "userinfo": state => state.user.userinfo
         }),
      },
      data() {
         return {
            activeIndex2: '1',
            keywork: "",
            showScrollButton: false,
            Current: null,
            messagenum: 0,
            navigationNum: 1,
            // userinfo:{},
            activeIndex: '1',
            input: "",
            defaultActive: '',
            search_text: '', //搜索文字
            keyStatus: false,
            keywordlist: [], //热门搜索词
         }
      },

      '$route': {
         handler(newVal, oldVal) {
            console.log('路由发生变化:', newVal, '旧值:', oldVal);
         },
         deep: true // 设置为true表示深度监听  
      },

      created() {},
      mounted() {},
      beforeDestroy() {},
      methods: {
         // 搜索
         onsearch() {
            if (this.keywork == '') {
               this.$message({
                  message: 'Enter search content',
                  type: 'warning'
               });
            } else {
               this.$router.push('/search/' + this.keywork)
            }
         },
         // 导航点击事件
         handleSelect(key, keyPath) {
            this.keywork = ''
            // localStorage.setItem('sd_userInfo', JSON.stringify(res.data));
            //   this.userinfo = JSON.parse(localStorage.getItem("sd_userInfo"));
            console.log(key, keyPath);
            localStorage.setItem('daohang', JSON.stringify(key));
            if (key == '1') {
               this.$router.push('/index')
            } else if (key == '2-1') {
               this.$router.push('/About_ISFAL')
            } else if (key == '2-2') {
               this.$router.push('/FoundersAndExperts')
            } else if (key == '2-3') {
               this.$router.push('/Partners')
            } else if (key == '2-4') {
               this.$router.push('/Contact_Us')
            } else if (key == '3-1') {
               this.$router.push('/Certification_System')
            } else if (key == '3-2') {
               this.$router.push('/Certification_Officers')
            } else if (key == '3-3') {
               this.$router.push('/Certificate_Search')
            } else if (key == '4-1') {
               this.$router.push('/Basic_Theory')
            } else if (key == '4-2') {
               this.$router.push('/Methodological_Tools')
            } else if (key == '4-3') {
               this.$router.push('/Key_Skills')
            } else if (key == '5-1') {
               this.$router.push('/Leadership_Development')
            } else if (key == '5-2') {
               this.$router.push('/Organizational_Development')
            } else if (key == '5-3') {
               this.$router.push('/Social_Development')
            } else if (key == '5-4') {
               this.$router.push('/Professional_Research')
            } else if (key == '6-1') {
               this.$router.push('/Ravens_Speech')
            } else if (key == '6-2') {
               this.$router.push('/Expert_Sharing')
            } else if (key == '6-3') {
               this.$router.push('/Professional_Publications')
            } else if (key == '7-1') {
               this.$router.push('/Conference/details/iEvIJj')
            } else if (key == '7-2') {
               this.$router.push('/Conference/details/100qweqwe123')
            }

         },
         scrollToTop() {
            window.scrollTo({
               top: 0,
               behavior: 'smooth' // Smooth scrolling animation
            });
         },
      }
   }
</script>
<style lang="less">
   /deep/ .el-submenu__title {
      font-size: 30px;
   }
</style>